module.exports = __webpack_public_path__ + "img/borderOctagonalWhite.9bf3dc0b.svg";